import { render, staticRenderFns } from "./SimplePagination.vue?vue&type=template&id=334d2f48&scoped=true"
import script from "./SimplePagination.vue?vue&type=script&lang=js"
export * from "./SimplePagination.vue?vue&type=script&lang=js"
import style0 from "./SimplePagination.vue?vue&type=style&index=0&id=334d2f48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334d2f48",
  null
  
)

export default component.exports